import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import { EAppsCounters, EStore } from '@enums';

import { capitalize, counters, getAppSchema } from '@utils';

import { IconEllipsesVertical } from '@base/assets/icons';

import {
	AppInstalls,
	AppTitle,
	Description,
	Dropdown,
	GenreList,
	Icon,
	JsonLdSchema, Link,
	Rating,
} from '@components';

import { AppItemPic } from './AppItemPic';

import { IAppItemProps } from './types';

import * as s from './AppItem.scss';

@inject(EStore.CURRENT_USER)
@observer
class AppItemContainer extends React.PureComponent<IAppItemProps & RouteComponentProps> {

	onOptionsClick = () => {
		counters.sendRB(EAppsCounters.APP_OPTIONS);
	};

	render() {
		const {
			app,
			className,
			classNamePic,
			descriptionLength,
			type,
			hasTitle,
			hasDescription,
			hasInstalls,
			hasGenres,
			getAppOptionsDropdownConfig,
			currentUserStore,
		} = this.props;
		const isMyCreated = Boolean(currentUserStore?.currentUser?.isMyCreated);
		// рейтинг показываем ТОЛЬКО НА SEO страницах
		const hasRating = isMyCreated ? false : this.props.hasRating;
		const {
			id,
			title,
			description,
			rating,
			installs,
			image,
			genres,
			isFake,
			voters,
			url,
		} = app;
		const blockClassName = classNames(
			className,
			s.block,
			{ [s[`block${capitalize(type)}`]]: Boolean(type) },
			{ [s.blockFake]: isFake },
		);
		const dropdownConfigs = getAppOptionsDropdownConfig ? getAppOptionsDropdownConfig(app) : null;

		return (
			<div className={blockClassName}>
				{ id &&
				(
					<JsonLdSchema
						id={id}
						schema={
							getAppSchema({
								id,
								title,
								description,
								genres,
								rating,
								voters,
								image,
							})
						}
					/>
				)
				}
				{ !isFake
					? <AppItemPic
						type={type}
						alt={title}
						className={classNames(s.pic, classNamePic)}
						src={image}
					/>
					: <div title={title} className={classNames(s.pic, s.picFake, classNamePic)}/>
				}
				<div className={s.text}>
					<div className={s.textInnerWrapper}>
						<div className={s.info}>
							{ hasTitle && <AppTitle className={classNames(s.title, { [s.fakeBlock]: isFake })} text={!isFake && title}/>}
							{
								(hasRating || hasInstalls) &&
								<div className={classNames(s.numbers, { [s.fakeBlock]: isFake })}>
									{
										!isFake && (
											<>
												{hasRating && <Rating className={s.numbersItem} rating={rating}/>}
												{hasInstalls &&
												<AppInstalls className={s.numbersItem} installs={installs}/>}
											</>
										)
									}
								</div>
							}
							{ hasGenres && (
								<div className={classNames(s.genres, { [s.fakeBlock]: isFake })}>
									<GenreList
										genres={genres}
									/>
								</div>
							)}
						</div>
						{ Boolean(dropdownConfigs) &&
							(
								<Dropdown
									onClick={this.onOptionsClick}
									className={s.option}
									button={
										<div className={s.optionButton}>
											<Icon
												className={s.optionIcon}
												glyph={IconEllipsesVertical}
											/>
										</div>
									}
									options={dropdownConfigs.options}
									positionHorizontal={dropdownConfigs.positionHorizontal}
									positionVertical={dropdownConfigs.positionVertical}
								/>
							)
						}
					</div>
					{ hasDescription &&
						(
							<Description
								className={classNames(s.description, { [s.fakeBlock]: isFake })}
								description={!isFake && description}
								length={descriptionLength}
							/>
						)
					}
				</div>
				<Link
					to={url}
					title={title}
					className={s.link}
				/>
			</div>
		);
	}

}

export const AppItem = withRouter(AppItemContainer);
